var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_set"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 8.69V6.125C23.0625 4.8875 22.05 3.875 20.8125 3.875H5.0625C3.81375 3.875 2.8125 4.8875 2.8125 6.125V21.875C2.8125 23.1125 3.81375 24.125 5.0625 24.125H20.8125C22.05 24.125 23.0625 23.1125 23.0625 21.875V19.31C23.7262 18.9162 24.1875 18.2075 24.1875 17.375V10.625C24.1875 9.7925 23.7262 9.08375 23.0625 8.69ZM21.9375 10.625V17.375H14.0625V10.625H21.9375ZM5.0625 21.875V6.125H20.8125V8.375H14.0625C12.825 8.375 11.8125 9.3875 11.8125 10.625V17.375C11.8125 18.6125 12.825 19.625 14.0625 19.625H20.8125V21.875H5.0625Z",
    fill: "#DD5800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 15.6875C18.3695 15.6875 19.125 14.932 19.125 14C19.125 13.068 18.3695 12.3125 17.4375 12.3125C16.5055 12.3125 15.75 13.068 15.75 14C15.75 14.932 16.5055 15.6875 17.4375 15.6875Z",
    fill: "#DD5800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWallet);
export default __webpack_public_path__ + "static/media/ic_wallet.dbd2d8c86f56266ab397f7e5ff15fcee.svg";
export { ForwardRef as ReactComponent };